import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class RecurringUpdateSample extends Component {
    getOrderId() {
        const { progLangId } = this.props;
        switch(progLangId) {
            case _DOTNET:
                return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
            case _JAVA:
                return `"Test"+createDate.getTime()`;
            case _PHP:
                return `'ord-'.date("dmy-G:i:s")`;
            default:
                return "";
        }
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    renderDOTNET() {
        const { storeId, apiToken, pan, expdate, amount } = this.props;
         return (
            <pre className="sampleCode">
{`using System;
using System.Collections;
public class TestCanadaPurchaseRecur
{ 
public static void Main(string[] args)
{   
string store_id = "`}{this.getValue(storeId, "storeId")}{`";
string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
string order_id = ${this.getOrderId()};
string cust_id = "antonio";
string recur_amount = "`}{this.getValue(amount, "amount")}{`";
string pan = "`}{this.getValue(pan, "pan")}{`";
string expiry_date = "`}{this.getValue(expdate, "expdate")}{`";
//string add_num = "";
//string total_num = "";
//string hold = "";
//string terminate = "";
string processing_country_code = "CA"; 
bool status_check = false;

CofInfo cof = new CofInfo(); 
cof.SetIssuerId("139X3130ASCXAS9"); 
RecurUpdate recurUpdate = new RecurUpdate(); 
recurUpdate.SetOrderId(order_id); 
recurUpdate.SetCustId(cust_id); 
recurUpdate.SetRecurAmount(recur_amount); 
recurUpdate.SetPan(pan);
recurUpdate.SetExpDate(expiry_date);
//recurUpdate.SetAddNumRecurs(add_num);
//recurUpdate.SetTotalNumRecurs(total_num);
//recurUpdate.SetHold(hold);
//recurUpdate.SetTerminate(terminate);
recurUpdate.SetCofInfo(cof);
HttpsPostRequest mpgReq = new HttpsPostRequest(); 
mpgReq.SetProcCountryCode(processing_country_code);
mpgReq.SetTestMode(true); //false or comment out this line for production transactions 
mpgReq.SetStoreId(store_id);
mpgReq.SetApiToken(api_token); 
mpgReq.SetTransaction(recurUpdate); 
mpgReq.SetStatusCheck(status_check); 
mpgReq.Send();
try
{
Receipt receipt = mpgReq.GetReceipt();
Console.WriteLine("ReceiptId = " + receipt.GetReceiptId()); 
Console.WriteLine("ResponseCode = " + receipt.GetResponseCode()); 
Console.WriteLine("Message = " + receipt.GetMessage()); 
Console.WriteLine("Complete = " + receipt.GetComplete()); 
Console.WriteLine("TransDate = " + receipt.GetTransDate()); 
Console.WriteLine("TransTime = " + receipt.GetTransTime()); 
Console.WriteLine("TimedOut = " + receipt.GetTimedOut()); 
Console.WriteLine("RecurUpdateSuccess = " + receipt.GetRecurUpdateSuccess()); 
Console.WriteLine("NextRecurDate = " + receipt.GetNextRecurDate()); 
Console.WriteLine("RecurEndDate = " + receipt.GetRecurEndDate()); 
Console.ReadLine();
}
catch (Exception e)
{
Console.WriteLine(e);
}
}
}
`}
            </pre>
        )
    }

  
   

    renderJAVA() {
        const { storeId, apiToken, pan, expdate, amount } = this.props;
        return (
            <pre className="sampleCode">
{`public class TestCanadaRecurUpdate
{
public static void main(String[] args) 
{
String store_id = "`}{this.getValue(storeId, "storeId")}{`";
String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
java.util.Date createDate = new java.util.Date();
String order_id = ${this.getOrderId()}; 
String cust_id = "antonio";
String recur_amount = "`}{this.getValue(amount, "amount")}{`";
String pan = "`}{this.getValue(pan, "pan")}{`";
String expiry_date = "`}{this.getValue(expdate, "expdate")}{`";
//String add_num = "";
//String total_num = "";
//String hold = "";
//String terminate = "";
String processing_country_code = "CA"; 
boolean status_check = false; //Credential on File details
CofInfo cof = new CofInfo(); 
cof.setIssuerId("139X3130ASCXAS9");
RecurUpdate recurUpdate = new RecurUpdate();
recurUpdate.setOrderId(order_id); 
recurUpdate.setCustId(cust_id); 
recurUpdate.setRecurAmount(recur_amount);
recurUpdate.setPan(pan);
recurUpdate.setExpdate(expiry_date);
//recurUpdate.setAddNumRecurs(add_num);
//recurUpdate.setTotalNumRecurs(total_num);
//recurUpdate.setHold(hold);
//recurUpdate.setTerminate(terminate);
recurUpdate.setCofInfo(cof);
HttpsPostRequest mpgReq = new HttpsPostRequest(); 
mpgReq.setProcCountryCode(processing_country_code);
mpgReq.setTestMode(true); //false or comment out this line for production transactions 
mpgReq.setStoreId(store_id);
mpgReq.setApiToken(api_token); 
mpgReq.setTransaction(recurUpdate); 
mpgReq.setStatusCheck(status_check); 
mpgReq.send();
try
{
Receipt receipt = mpgReq.getReceipt();
System.out.println("ReceiptId = " + receipt.getReceiptId()); 
System.out.println("ResponseCode = " + receipt.getResponseCode()); 
System.out.println("Message = " + receipt.getMessage()); 
System.out.println("Complete = " + receipt.getComplete()); 
System.out.println("TransDate = " + receipt.getTransDate()); 
System.out.println("TransTime = " + receipt.getTransTime()); 
System.out.println("TimedOut = " + receipt.getTimedOut()); 
System.out.println("RecurUpdateSuccess = " + receipt.getRecurUpdateSuccess()); 
System.out.println("NextRecurDate = " + receipt.getNextRecurDate()); 
System.out.println("RecurEndDate = " + receipt.getRecurEndDate());
}
catch (Exception e)
{
e.printStackTrace();
}
}
}
`}
            </pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken, pan, expdate, amount } = this.props;

        return (
            <pre className="sampleCode">
{`
<?php
##
## Example php -q TestRecurUpdate.php store1
##
require "../../mpgClasses.php";
/**************************** Request Variables *******************************/ $store_id='store5';
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';
/************************* Transactional Variables ****************************/ $type='recur_update';
$cust_id='my cust id';
$order_id='ord-110515-10:45:21';
$recur_amount='`}{this.getValue(amount, "amount")}{`';
$pan='`}{this.getValue(pan, "pan")}{`';
$expiry_date='`}{this.getValue(expdate, "expdate")}{`';
$add_num='';
$total_num='7';
$hold = 'false';
$terminate = 'false';
/*********************** Transactional Associative Array **********************/ $txnArray=array('type'=>$type,
'order_id'=>$order_id,
'cust_id'=>$cust_id,
'recur_amount'=>$recur_amount,
'pan'=>$pan,
'expdate'=>$expiry_date,
'add_num_recurs' => $add_num,
'total_num_recurs' => $total_num,
'hold' => $hold,
'terminate' => $terminate
);
/******************* Credential on File **********************************/
$cof = new CofInfo();
$cof->setIssuerId("168451306048014");
/**************************** Transaction Object *****************************/
$mpgTxn = new mpgTransaction($txnArray);
$mpgTxn->setCofInfo($cof);
/****************************** Request Object *******************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions 
/***************************** HTTPS Post Object *****************************/ 
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest); 
/******************************* Response ************************************/ 
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\nReceiptId = " . $mpgResponse->getReceiptId());
print("\nResponseCode = " . $mpgResponse->getResponseCode()); 
print("\nMessage = " . $mpgResponse->getMessage());
print("\nComplete = " . $mpgResponse->getComplete());
print("\nTransDate = " . $mpgResponse->getTransDate()); 
print("\nTransTime = " . $mpgResponse->getTransTime()); 
print("\nTimedOut = " . $mpgResponse->getTimedOut()); 
print("\nRecurUpdateSuccess = " . $mpgResponse->getRecurUpdateSuccess()); 
print("\nNextRecurDate = " . $mpgResponse->getNextRecurDate()); 
print("\nRecurEndDate = " . $mpgResponse->getRecurEndDate());
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, orderId, pan, expdate, amount, currency, onEditId } = state.recurring.main.config;
    const { selection } = state.common.progLangList;
    return { storeId, apiToken, orderId, pan, expdate, amount, currency, progLangId: selection, onEditId };
  }
  
  export default connect(mapStateToProps, {})(RecurringUpdateSample)